<template>
  <router-view/>
  <!-- 全站自定义鼠标指针（后台页面里不生效；没开启/没配就什么都不做） -->
  <CustomCursor />
  <!-- Live2D 皮套：首页 / 作品 / 积分兑换 / 舰长礼物 / 歌单 / 关于 都会显示，后台页面自动隐藏 -->
  <Live2dPuppet />
</template>
<script>
import CustomCursor from './components/Cursor/CustomCursor.vue';
import Live2dPuppet from './components/Live2D/Live2dPuppet.vue';

const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

export default {
  name: 'App',
  components: { CustomCursor, Live2dPuppet }
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
}
::-webkit-scrollbar{
  width:3px;
  height:5px;
  position:absolute;
}
::-webkit-scrollbar-thumb{
  background: #1890ff;
}
::-webkit-scrollbar-track{
  background: #ddd;
}
</style>
